export default {
  cn: [
    {
      version: '2.1.4',
      time: '2019.08.18',
      changes: [
        '增加 <b>葡萄牙语(巴西)</b>, 语言关键字: <code>pt_br</code>',
        '修改 css 预编译程序从 <b>SCSS</b> 至 <b>Stylus</b>',
        '使用 <b>Javascript Standard</b> 语法标准对项目进行格式化',
        '升级 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> 升级至 v2.1.0 版本'
      ]
    }, {
      version: '2.1.2',
      time: '2019.07.04',
      changes: [
        '使用 render 方式完全重构插件',
        '样式简洁化，减少线条的使用',
        '优化部分操作和数据处理性能',
        '修复部分情况下数据请求重复触发问题',
        '修复部分情况下，输入查询无效的问题',
        '增加 <code>rtl</code> 内容右对齐模式下，查询输入框的输入方向修改为从右向左展示模式',
        '增加 <b>西班牙语</b>，语言关键字：<code>es</code>',
        '增加 <b>德语</b>，语言关键字：<code>de</code>',
        '增加 <b>罗马尼亚语</b>，语言关键字：<code>ro</code>',
        '增加 <b>法语</b>，语言关键字：<code>fr</code>'
      ]
    }, {
      version: '2.0.2',
      time: '2019.01.03',
      changes: [
        '重构插件',
        '修改 <strong>iconfont</strong> 字体名称，以免与实际项目中的字体名称冲突',
        '修复部分情况下全选当前页功能无效的问题',
        '修复服务端数据模式可能存在多次加载数据问题，并在选择项目后，出现新选择的项目与原选择项目交替闪烁的情况',
        '增加 <code>rtl</code> 参数允许内容和下拉层向右对齐，以适配部分国家和语言的向右排版的需求',
        '增加 <code>disabled</code> 参数设置插件禁用状态，同时去除 <code>disabled</code> 的 <strong>api</strong>',
        '增加 <code>width</code> 参数用于指定下拉层的宽度，不指定则根据内容自适应',
        '增加 <b>阿拉伯语</b>，语言关键字：<code>ar</code>',
        '修改最大选择项目个数限制提示方式',
        '下拉菜单容器使用插件 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>'
      ]
    }, {
      version: '1.0.1 - 1.0.15',
      time: '2018.07.05',
      changes: [
        '修复下拉菜单超出屏幕后的处理',
        '使用 <code>v-model</code> 属性取代 selected 参数， 作为插件初始化，以及数据值返回的对象',
        '修复消息窗口图标错位',
        '修复部分情况下无边框的情况',
        '修复部分浏览器在弹出列表后，页面会滚动到顶部'
      ]
    }, {
      version: '1.0',
      time: '2018.06.30',
      changes: [
        '开发并发布基于 <strong>Vue2</strong> 的 <code>v-selectpage</code> 插件'
      ]
    }
  ],

  en: [
    {
      version: '2.1.4',
      time: '2019.08.18',
      changes: [
        'Add <b>Portuguese-Brazil</b>, the language key: <code>pt_br</code>',
        'Change css pre-processor program from <b>SCSS</b> to <b>Stylus</b>',
        'Use <b>Javascript Standard</b> Style to format code',
        'Upgrade <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> plugin to v2.1.0'
      ]
    }, {
      version: '2.1.2',
      time: '2019.07.04',
      changes: [
        'Use render functions to completely rebuild plugin',
        'Make plugin style more simple, reduce the use of lines',
        'Optimize some operations and data processing performance',
        'Fixed duplicate data request in some cases',
        'Fixed search input not working in some cases',
        'Add in <code>rtl</code> mode(content align to right), change input direction by right to left',
        'Add <b>Spanish</b> language, the language key: <code>es</code>',
        'Add <b>German</b> language, the language key: <code>de</code>',
        'Add <b>Romanian</b> language, the language key: <code>ro</code>',
        'Add <b>French</b> language, the language key: <code>fr</code>'
      ]
    }, {
      version: '2.0.2',
      time: '2019.01.03',
      changes: [
        'Rebuild plugin',
        'Change iconfont name and class name, avoid conflicts with iconfont content in the user environment',
        'Fixed select current page functional failure in some cases',
        'Fixed duplicate request issue in server side mode, and v-model variable will auto change when selected some item',
        'Add <code>rtl</code> option to set drop down container layer and inner content align to the right, to adapt to the needs of some countries/language to the right',
        'Add <code>disabled</code> option to disabled plugin and removed <code>disabled</code> <strong>api</strong>',
        'Add <code>width</code> option to set drop down container layer width, if not set, the drop down container layer width will adaptive by inner content',
        'Add <b>Arabic language, the language key <code>ar</code>',
        'Modify the max selected limit item prompt mode',
        'The drop down container layer change to plugin <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>'
      ]
    }, {
      version: '1.0.1 - 1.0.15',
      time: '2018.07.05',
      changes: [
        'Fixed auto position for drop down list over screen was not working',
        'use <code>v-model</code> replace <code>selected</code> option, to init selected item and return selected items key',
        'Fixed message box icon dislocation',
        'Fixed plugin without border in sometime',
        'Fixed some browser when open drop down list, the viewport will scroll to top'
      ]
    }, {
      version: '1.0',
      time: '2018.06.30',
      changes: [
        'Develop and publish <code>v-selectpage</code> plugin for <strong>Vue2</strong>'
      ]
    }
  ]
}
